<template>
  <div class="container" id="container">
    <div class="inner">
      <div>
        <div class="top">
          <h3>{{time}}</h3>
          <p>{{today}}</p>
        </div>
        <h3 class="titles">选择影片及场次</h3>
        <div class="swiper" v-if="listData.length>0">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item,index) in listData"
                :key="index"
                :style="'background-image:url('+item.img+')'"
              ></div>
            </div>
          </div>
        </div>
        <h3 class="title" v-if="listData.length>0">{{listData[cur].movie_name}}</h3>
        <p class="des">温馨提示：滨海科技馆影院自助售票机只出售当日影票，电影开场前5分钟停止售票，开场前10分钟停止退票。</p>
        <div class="btns">今天{{day}}</div>
        <!-- 预约时段列表 -->
        <div class="content" v-if="listData.length>0">
          <div
            class="item"
            v-for="(item,index) in list"
            :key="index"
            :class="{'active':item.status==1}"
          >
            <div class="title-wrapper">
              {{item.start_time}}
              <span :class="{'active':item.status==1}">￥{{listData[cur].price}}</span>
            </div>
            <p>
              片长：{{listData[cur].long_time}}分钟
              <span class="num-wrapper">
                剩余：
                <span>{{item.sur_count}}</span>张
              </span>
            </p>
            <div
              class="btn active"
              v-if="item.status==1"
              @click="goBuy(item.film_date_layout_id,item.start_time)"
            >在售</div>
            <div class="btn" v-if="item.status==2">停售</div>
            <div class="btn" v-if="item.status==3">售罄</div>
          </div>
        </div>
        <div class="footer">
          <p>
            <!-- 设备ID：{{deviceId}} -->
            <span class="tel">
              客服电话
              <span>25650850 25650860</span>
            </span>
          </p>
        </div>
        <div class="back" @click.self="goBack">退出</div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { setInterval, clearInterval, setTimeout } from "timers";
export default {
  name: "HelloWorld",
  data() {
    return {
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      day: "",
      timer: "",
      cur: 0,
      listData: [],
      list: []
    };
  },
  mounted() {
    this.getDay();
    this.getMovie();
    this.getScroll();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
    var that = this;
    this.$once("hook:beforeDestroy", function() {
      clearInterval(that.timer);
    });
  },
  methods: {
    goBack() {
      this.$router.replace("/");
    },
    goBuy(id, time) {
      var type = this.listData[this.cur].movie_type;
      if (type == 3) {
        this.$router.push({
          path: "/test",
          query: {
            id: this.listData[this.cur].movie_id,
            name: this.listData[this.cur].movie_name,
            price: this.listData[this.cur].price,
            film_date_layout_id: id,
            time: time
          }
        });
        return false;
      }
      this.$router.push({
        path: "/seat",
        query: {
          id: this.listData[this.cur].movie_id,
          name: this.listData[this.cur].movie_name,
          price: this.listData[this.cur].price,
          film_date_layout_id: id,
          time: time
        }
      });
    },
    getMovie() {
      this.$api.getMovie().then(res => {
        if (res.status == 1) {
          if (res.data.length > 0) {
            this.listData = res.data;
            this.list = res.data[0].list;
            setTimeout(() => {
              this.initSwiper();
            }, 300);
          }
        }
      });
    },
    initSwiper() {
      let vm = this;
      var mySwiper = new Swiper(".swiper-container", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 30,
          modifier: 1,
          slideShadows: true
        },
        onTouchEnd: function(swiper) {
          vm.cur = swiper.realIndex;
          vm.list = vm.listData[vm.cur].list;
        }
      });
    },
    getScroll() {
      var $inner = document.getElementsByClassName("inner")[0];
      var $container = document.getElementById("container");

      var y1 = 0;
      var y2 = 0;
      var height = 0;
      $inner.addEventListener("touchstart", function(event) {
        y1 = event.touches[0].pageY;
      });
      $inner.addEventListener("touchmove", function(event) {
        y2 = event.touches[0].pageY;
        height = y2 - y1;
        var top = document.documentElement.scrollTop || document.body.scrollTop;

        if (height > 0) {
          document.documentElement.scrollTop = top - y2 + y1;
          document.body.scrollTop = top - y2 + y1;
        } else {
          document.documentElement.scrollTop = top + y1 - y2;
          document.body.scrollTop = top + (y1 - y2);
        }
      });
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.day = month + "月" + days + "日 ";
      this.today = month + "月" + days + "日 " + strWeek;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  background: #f0f0f0;
  overflow-y: scroll;
  position: relative;
  padding-bottom: 165px;
  .inner {
    height: auto;
  }
  .top {
    padding: 30px 32px;
    color: #4d4d4d;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
  }
  .titles {
    font-size: 60px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: left;
    margin: 85px 60px 50px;
  }
}
.swiper {
  height: 400px;
  background: #3b3b3b;
  padding: 25px;
  padding: 25px;
  overflow: hidden;
  .swiper-container {
    width: 100%;
    height: 350px;
    .swiper-slide {
      background-position: center;
      background-size: cover;
      width: 420px;
      height: 315px;
    }
    /deep/ .swiper-slide-active {
      width: 460px;
      height: 345px;
    }
  }
}
.title {
  color: #272727;
  font-size: 36px;
  text-align: center;
  margin: 25px auto 50px;
}
.des {
  color: #858585;
  font-size: 26px;
  padding: 0 100px 60px;
  line-height: 40px;
  font-weight: 500;
  text-align: center;
}
.btns {
  padding: 20px 0px;
  background: #005192;
  color: #fff;
  font-size: 30px;
  width: 248px;
  text-align: center;
  margin-left: 40px;
  border-radius: 4px;
}
.content {
  padding: 40px;
  .item {
    width: 100%;
    border-radius: 6px;
    padding: 0 40px;
    background: #e1e1e1;
    position: relative;
    margin-bottom: 30px;
    &.active {
      background: #fff;
    }
    .title-wrapper {
      overflow: hidden;
      font-size: 40px;
      color: #5a5a5a;
      font-weight: 500;
      padding-top: 35px;
      padding-right: 326px;
      margin-bottom: 30px;
      span {
        float: right;
        .active {
          color: #ff5a00;
        }
      }
    }
    p {
      font-size: 30px;
      color: #5a5a5a;
      padding-right: 326px;
      padding-bottom: 28px;
      overflow: hidden;
      .num-wrapper {
        float: right;
      }
    }
    .btn {
      position: absolute;
      width: 207px;
      height: 74px;
      line-height: 74px;
      text-align: center;
      border-radius: 6px;
      background: #cdcdcd;
      top: 50%;
      right: 60px;
      transform: translateY(-50%);
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      &.active {
        background: #b95020;
      }
    }
  }
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  top: 55%;
  right: 0;
  z-index: 998;
  font-weight: 500;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 60px;
  font-size: 24px;
  width: 100%;
  p {
    color: #5a5a5a;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #1c78f7;
      font-size: 20px;
      display: inline-block;
      vertical-align: middle;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Buy.vue